<style>
    .top_line {
        display: flex;
        position: relative;
    }
    .top_line_image {
        width: 88px;
        margin-right: 6px;
    }
    .top_line_image img {
        width: 88px;
        height: 88px;
        object-fit: cover;
    }
    .top_line_category {
        flex: 1;
        align-items: center;
        display: flex;
        font-size: 14px;
        line-height: 13px;
        color: #404455;
    }
    .top_line_category img {
        width: 36px;
        height: 36px;
        object-fit: contain;
        margin-right: 6px;
    }
    .delete_item {
        background: url("./images/delete.png") center no-repeat;
        background-size: contain;
        cursor: pointer;
        width: 23px;
        height: 23px;
    }
    .top_line_category_name {

    }
    .description {
        padding-top: 15px;
        font-size: 14px;
        line-height: 13px;
        color: #404455;
    }
    .item {
        display: block;
        padding-top: 20px;
    }
</style>

<script >
    import { mutations, combinedArray, modalTitle } from '../mainStore.js';

    export let item

    function getItemImage(item) {
        if (item.prev_image) {
            return item.prev_image
        }
        return getDummy()
    }
    function getDummy(){
        return "/build/images/No Image.png"
    }
    function getImage(item) {
        if(item.icon_image){
            return item.icon_image
        } else {
            if(item.category.image) {
                return item.category.image
            }
            return getDummy()
        }
    }

    function deleteItem() {
        mutations.setModalState({
            modalType: "oneItem",
            modalState: item,
            modalTitle: $modalTitle,
            showModal: true,
            item: item,
        })
        mutations.setModalType("confirmation")
        mutations.setShowModal(true)
        mutations.setModalTitle("")
    }
</script>

<div class="item">
    <div class="top_line">
        <div class="top_line_image">
            <img src="{getItemImage(item)}" alt="">
        </div>
        <div class="top_line_category">
            <img src="{getImage(item)}" alt="">
            <div class="top_line_category_name">
                {item.category.name}
            </div>
        </div>
        <div class="delete_item" on:click={() => deleteItem(item)} ></div>
    </div>
    <div class="description">
        {@html item.description}
    </div>
</div>
